import Vue from 'vue'
import i18n, { loadRemoteLocaleMessages } from './services/i18n'
import router from './router'
import store from './store'
import App from './App.vue'
import registerGlobalComponents from './components/shared/global/register'
import registerGlobalFormsComponents from './components/shared/global-forms/register'
import registerGlobalCoursesItemsComponents from './components/shared/global-courses-items/register'
import 'normalize.css'
import '@/assets/scss/global.scss'
import VueMeta from 'vue-meta'
import VModal from 'vue-js-modal'
import VueMq from 'vue-mq'
import moment from 'moment'
import envSupportPlugin from './envSupportPlugin'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import Router from 'vue-router'
import config from 'services/config'
import VueNumber from 'vue-number-animation'
import VueApexCharts from 'vue-apexcharts'
import 'vue-easytable/libs/theme-default/index.css'
import VueEasytable from 'vue-easytable'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'

Vue.config.productionTip = false
Vue.use(Router)
Vue.use(VueMeta)
Vue.use(VModal, {
    dialog: true,
    dynamic: true,
    injectModalsContainer: true
})
Vue.use(require('vue-moment'))
Vue.use(envSupportPlugin)
Vue.use(VueNumber)
Vue.use(VueMq, {
    breakpoints: {
        mobile_sm: 576,
        mobile_md: 992,
        desktop_l: 1080,
        desktop_xl: 1200,
        desktop_xxl: 1400,
        desktop_xxxl: Infinity
    }
})
Vue.use(VueApexCharts)
Vue.use(VueEasytable)
Vue.mixin({
    computed: {
        isMobileView () {
            return this.$mq.includes('mobile')
        },
        isMobileSmallView () {
            return this.$mq.includes('mobile_sm')
        },
        isDesktopView () {
            return this.$mq.includes('desktop')
        },
        isDesktopSmallView () {
            return this.$mq.includes('desktop_l') || this.$mq.includes('desktop_xl')
        }
    }
})
Vue.use(Loading)
Vue.use(Toast, {
    transition: 'Vue-Toastification__bounce',
    maxToasts: 20,
    newestOnTop: true
})

registerGlobalComponents(Vue)
registerGlobalFormsComponents(Vue)
registerGlobalCoursesItemsComponents(Vue)
Vue.component('apexchart', VueApexCharts)
Vue.use(FloatingVue)
let language
if (config.appLanguage === 'se') {
    language = 'sv'
} else {
    language = config.appLanguage
}

moment.locale(language)

Vue.use(VueCookieBot, {
    cookieBotID: config.cookieBotConsentId
})

router.beforeEach((to, from, next) => {
    if (from.name && from.name !== to.name) {
      store.dispatch('Breadcrumb/setLastRoute', from)
    }
    next()
})

const app = new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
})

loadRemoteLocaleMessages().then(() => {
    app.$mount('#app')
})
